import type { FaireProductEntity } from "../../entity_types/product";

export const p_cwyvvye7vs: FaireProductEntity = {
  token: "p_cwyvvye7vs",
  type: "product",
  name: "Falling Leaves Little Notes® | Autumn Fall mini notes",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/fa1cfdf65fa990f83b8afbdc66a8db504abfa3a4bf0ed46dbee45ca5e67d4571.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/759618b4cfdbac09a8de162a6b8199e1bd752a48e4f5f2da5fdaef1988d8f9f4.jpeg",
    "https://cdn.faire.com/fastly/756f00cab51e8447682050b11a13afdb5bad36133c7da398151ca72679aedfd1.jpeg",
    "https://cdn.faire.com/fastly/361c7499a31da849dc81802d9f1f4ca79cbc2633385d73d93cb4f946ae2b3aa9.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:33.617Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
